import React from 'react'
import styles from 'common/SearchableCard/SearchableCard.scss'
import {SegmentMatchListItem} from 'common/ListItems'
import {SearchableCard} from 'common/SearchableCard'
import {IntroWidget} from 'common/IntroWidget'
import {DEFAULT_PER_PAGE} from 'lib/loadAllPages'
import {CTA} from 'common/styleguide/CTA'

export class MatchedSegments extends React.PureComponent {
  state = {
    keywords: '',
    limit: DEFAULT_PER_PAGE
  }

  loadMore = () => {
    this.setState((state) => ({limit: state.limit + DEFAULT_PER_PAGE}))
  }

  render () {
    const {keywords, limit} = this.state
    const {segmentMatches} = this.props

    const matches = keywords
      ? segmentMatches.filter(({name}) => name.toLowerCase().includes(keywords.toLowerCase()))
      : segmentMatches
    const toShow = matches.slice(0, limit)
    return (
      <SearchableCard
        keywords={keywords}
        onChange={e => this.setState({keywords: e.target.value, limit: DEFAULT_PER_PAGE})}
        resultsCount={matches.length}
        resultsLength={toShow.length}>
        {toShow.map(match => <SegmentMatchListItem
          key={match.slug}
          match={match} />)}
        {segmentMatches.length === 0 && !keywords &&
          <IntroWidget large i='md-podium' link={<a href='https://ridewithgps.com/help/segments' target='_blank'>Learn About Segments</a>}>
            You have no matched segments
          </IntroWidget>}
        {toShow.length === 0 && keywords.length > 0 &&
          <IntroWidget large i='md-podium'>
            No segments matched your search
          </IntroWidget>}
        {matches.length > toShow.length &&
          <div className={styles.resultsFooter}>
            <CTA inline secondary margins={false} onClick={() => this.loadMore()}>
              Load more
            </CTA>
            <div style={{ paddingTop: '20px' }}>
              <span className={styles.footerText}>Showing 1 - {toShow.length} of {matches.length} results</span>
            </div>
          </div>}
        {matches.length === toShow.length &&
          toShow.length > DEFAULT_PER_PAGE &&
          <div className={styles.resultsFooter}>
            <span className={styles.footerText}>No more items to display</span>
          </div>}
      </SearchableCard>
    )
  }
}
